<div
  class="simple-table"
  #tableWrapper
  [class.simple-table--borderless]="borderless"
  [class.simple-table--compact]="isCompactMode"
>
  <div class="simple-table__scroll-container" #bodyContainer>
    <div class="simple-table__content">
      <div class="simple-table__header" [style.grid-template-columns]="gridTemplateColumns">
        @for (column of columns; track $index) {
          <div
            class="simple-table__cell simple-table__cell--header"
            [class.simple-table__cell--header-filterable]="
              column.filters && column.filters.length > 0
            "
            [style.padding]="column.padding"
            (click)="column.filters?.length && toggleFilters(column.key, $event)"
          >
            <span
              class="simple-table__cell-text"
              [style.text-align]="column.align"
              [title]="column.label"
              >{{ column.label }}</span
            >

            @if (column.filters && column.filters.length > 0) {
              <button
                class="simple-table__filter--button"
                [class.simple-table__filter--button-active]="hasActiveFilter(column.key)"
              >
                <img src="assets/icons/funnel.svg" alt="" />
              </button>
            }

            @if (showFilters[column.key]) {
              <div class="simple-table__filter-menu" [attr.data-filter-menu]="column.key">
                @if (hasFilter(column, 'search')) {
                  <div class="simple-table__filter-option">
                    <label>{{ translateData?.search_label || 'Search:' }}</label>
                    <div class="simple-table__search-container">
                      <input
                        type="text"
                        class="simple-table__filter--search"
                        placeholder="{{ translateData?.search_column_placeholder || 'Search' }} {{
                          column.label
                        }}"
                        [value]="searchValues[column.key] || ''"
                        (input)="onSearch($event, column.key)"
                        (keydown)="onFilterKeydown($event, column.key)"
                      />
                      @if (searchValues[column.key]) {
                        <button
                          class="simple-table__clear-search"
                          (click)="clearSearch(column.key)"
                          [title]="translateData?.clear_search_title || 'Clear search'"
                        >
                          ×
                        </button>
                      }
                    </div>
                  </div>
                }

                @if (hasFilter(column, 'search') && hasFilter(column, 'sort')) {
                  <div class="simple-table__divider"></div>
                }

                @if (hasFilter(column, 'sort')) {
                  <div class="simple-table__filter-option">
                    <label>{{ translateData?.sort_label || 'Sort:' }}</label>
                    <button
                      class="simple-table__filter--button-option"
                      (click)="onSort(column.key, 'asc')"
                      [title]="translateData?.sort_asc_title || 'Sort A to Z'"
                    >
                      {{ translateData?.sort_asc || '↑ A to Z' }}
                    </button>

                    <button
                      class="simple-table__filter--button-option"
                      (click)="onSort(column.key, 'desc')"
                      [title]="translateData?.sort_desc_title || 'Sort Z to A'"
                    >
                      {{ translateData?.sort_desc || '↓ Z to A' }}
                    </button>
                  </div>
                }

                @if (
                  (hasFilter(column, 'location-search') && hasFilter(column, 'sort')) ||
                  (hasFilter(column, 'location-search') && hasFilter(column, 'search'))
                ) {
                  <div class="simple-table__divider"></div>
                }

                @if (hasFilter(column, 'location-search')) {
                  <div class="simple-table__filter-option">
                    <label>{{ translateData?.location_search_label || 'Location Search:' }}</label>
                    <app-filter-location-search
                      [rows]="originalRows"
                      (rowsEmit)="onFilterLocationChanged($event)"
                      [initialSearchValue]="initLocationSearch"
                      (searchValueChange)="onSearchValue($event)"
                      [checks]="checkSaves"
                    ></app-filter-location-search>
                  </div>
                }

                @if (
                  (hasFilter(column, 'category-filter') && hasFilter(column, 'sort')) ||
                  (hasFilter(column, 'location-search') && hasFilter(column, 'search'))
                ) {
                  <div class="simple-table__divider"></div>
                }

                @if (hasFilter(column, 'category-filter')) {
                  <div class="simple-table__filter-option">
                    <label>{{ translateData?.categories_label || 'Categories:' }}</label>
                    <app-categories-search
                      [tableRows]="originalRows"
                      (rowsEmit)="onFilterCategoryChanged($event)"
                      [initialSearchValue]="initCategorySearch"
                      [checks]="categorySaves"
                      [categoryField]="'map_categories'"
                    >
                    </app-categories-search>
                  </div>
                }

                @if (hasFilter(column, 'roles-filter')) {
                  <div class="simple-table__filter-option">
                    <label>{{ translateData?.roles_label || 'Roles:' }}</label>
                    <app-categories-search
                      [tableRows]="originalRows"
                      (rowsEmit)="onFilterCategoryChangedForField('roles', $event)"
                      [initialSearchValue]="''"
                      [checks]="categoryFilters['roles']?.saves || emptySet"
                      [categoryField]="'roles'"
                    >
                    </app-categories-search>
                  </div>
                }

                @if (hasActiveFilter(column.key)) {
                  <div class="simple-table__divider"></div>
                  <button
                    class="simple-table__filter--clear-all"
                    (click)="clearAllFilters(column.key)"
                    [title]="translateData?.clear_all_filters || 'Clear All Filters'"
                  >
                    {{ translateData?.clear_all_filters || 'Clear All Filters' }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="simple-table__body">
        @for (row of displayedRows; track $index) {
          <div
            class="simple-table__row"
            [style.grid-template-columns]="gridTemplateColumns"
            [class.simple-table__row--clickable]="
              rowClickable && !(isRowDisabled && isRowDisabled(row))
            "
            [class.simple-table__row--disabled]="isRowDisabled && isRowDisabled(row)"
            [ngClass]="rowClassFn ? rowClassFn(row) : null"
            (click)="onRowClick(row, $event)"
            (dblclick)="onRowDoubleClick(row)"
            (mouseenter)="onRowMouseEnter(row)"
            (mouseleave)="onRowMouseLeave()"
            (touchstart)="onRowTouchStart(row, $event)"
            (touchend)="onRowTouchEnd(row, $event)"
            (touchcancel)="onRowTouchCancel(row, $event)"
          >
            @for (column of columns; track $index) {
              <div
                class="simple-table__cell"
                [style.padding]="column.padding"
                [title]="hasTemplate(column) ? '' : getCellValue(row, column)"
              >
                @if (hasTemplate(column)) {
                  <ng-container
                    *ngTemplateOutlet="
                      getTemplate(column);
                      context: getTemplateContext(row, column)
                    "
                  >
                  </ng-container>
                } @else {
                  <span class="simple-table__cell-text">{{ getCellValue(row, column) }}</span>
                }
              </div>
            }
          </div>
        }

        @if (displayedRows.length === 0 && !loading) {
          <div class="simple-table__no-data">
            {{ noDataMessage || translateData?.no_data_available || 'No data available' }}
          </div>
        }
      </div>
    </div>
  </div>

  @if (pageSize && pageSize > 0 && (lazy ? totalRecords : rows.length) > 0) {
    <div class="simple-table__pagination" [class.simple-table__pagination--compact]="width < 620">
      @if (!hidePaginationInfo) {
        <div class="simple-table__pagination-info">
          @if (width >= 620) {
            {{ translateData?.showing || 'Showing' }} {{ (currentPage - 1) * pageSize + 1 }}
            {{ translateData?.to || 'to' }}
            {{ Math.min(currentPage * pageSize, lazy ? totalRecords : rows.length) }}
            {{ translateData?.of || 'of' }} {{ lazy ? totalRecords : rows.length }}
            {{ translateData?.rows || 'rows' }}
          } @else {
            {{ (currentPage - 1) * pageSize + 1 }} /
            {{ Math.min(currentPage * pageSize, lazy ? totalRecords : rows.length) }}
            {{ translateData?.of || 'of' }} {{ lazy ? totalRecords : rows.length }}
          }
        </div>
      }

      <div
        class="simple-table__pagination-controls"
        [class.simple-table__pagination--no-info]="hidePaginationInfo"
      >
        <button
          class="simple-table__pagination-button"
          [disabled]="currentPage === 1"
          (click)="changePage(1)"
          [title]="translateData?.first_page || 'First page'"
        >
          «
        </button>

        <button
          class="simple-table__pagination-button"
          [disabled]="currentPage === 1"
          (click)="changePage(currentPage - 1)"
          [title]="translateData?.previous_page || 'Previous page'"
        >
          ‹
        </button>

        @for (page of getPageNumbers(); track $index) {
          @if (page === -1) {
            <span class="simple-table__pagination-ellipsis">...</span>
          } @else {
            <button
              class="simple-table__pagination-button"
              [class.simple-table__pagination-button--active]="page === currentPage"
              (click)="changePage(page)"
            >
              {{ page }}
            </button>
          }
        }

        <button
          class="simple-table__pagination-button"
          [disabled]="currentPage === totalPages"
          (click)="changePage(currentPage + 1)"
          [title]="translateData?.next_page || 'Next page'"
        >
          ›
        </button>

        <button
          class="simple-table__pagination-button"
          [disabled]="currentPage === totalPages"
          (click)="changePage(totalPages)"
          [title]="translateData?.last_page || 'Last page'"
        >
          »
        </button>
      </div>

      @if (width >= 601) {
        <div class="simple-table__pagination-size">
          <label for="pageSize">{{ translateData?.rows_per_page || 'Rows per page:' }}</label>
          <select
            id="pageSize"
            class="simple-table__pagination-select"
            (change)="changePageSize($event)"
          >
            @for (size of pageSizeOptions; track size) {
              <option [value]="size" [selected]="size === pageSize">{{ size }}</option>
            }
          </select>
        </div>
      }
    </div>
  }

  @if (loading) {
    <div class="simple-table__loading" role="status" aria-live="polite" aria-busy="true">
      <span class="simple-table__spinner" aria-hidden="true"></span>
    </div>
  }
</div>
